import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementPurchaseCountWidget: DashboardWidgetConfiguration = {
  widgetId: "procurement.purchase-count",
  name: "Purchase documents",
  description: "Purchase documents for the selected dashboard period.",
  apps: [
    "home",
    "procurement",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "procurement.purchases",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "purchase_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Purchases",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 47,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
